import { alpha, SxProps, TextField, TextFieldProps, Theme } from '@mui/material';

const customStyles: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    paddingRight: 'unset',
    backgroundColor: '#FFFFFF',
    minHeight: '32px',
    height: '32px',
    boxSizing: 'border-box',
    '&.MuiInputBase-multiline': {
      height: 'auto',
      minHeight: 'unset',
      padding: '0px',
      '& .MuiInputBase-input': {
        padding: '6px 12px !important',
        height: 'auto',
        minHeight: '64px',
        lineHeight: '20px',
        borderRadius: '8px',
      },
    },
    '&.Mui-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme: Theme) => `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme: Theme) => `1px solid ${theme.palette.error.main}`,
          boxShadow: (theme: Theme) => `0 0 0 2px ${alpha(theme.palette.error.main, 0.1)}`,
        },
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme: Theme) => `1px solid ${theme.palette.secondary.light}`,
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
        boxShadow: (theme: Theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.1)}`,
        outline: 'none',
      },
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: (theme: Theme) => theme.palette.primary.main,
      },
    },
    '& .MuiInputBase-input': {
      padding: '0 12px !important',
      height: '32px',
      lineHeight: '32px',
      boxSizing: 'border-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '&.Mui-disabled': {
      backgroundColor: '#F3F5F9',
    },
  },
};

// Styled Input component that extends the Material UI TextField component
export function Input(props: TextFieldProps) {
  return (
    <TextField
      {...props}
      sx={customStyles}
    />
  );
}
